import axios from "axios";
import React, { useEffect, useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import Table from 'react-bootstrap/Table';

import Breadcrumb from "../Component/BradeCrum";
import HeaderMobile from "../Component/MobileHader";
import { object } from "yup";
import { Hourglass } from "react-loader-spinner";

const CustomerPage = () => {
  const [content, setContent] = useState([]);
  const [loading, setLoading] = useState(true);

 
  useEffect(() => {
    
    axios
      .get(`${process.env.REACT_APP_GRIPHOLD_API_URL}/api/auth/get/allcostomer`)
      .then((res) => {
        const getData = res.data;

        setContent(getData); // Directly store the fetched data
  

      })
      .catch((err) => console.log(err));
  }, []);
    useEffect(() => {
      const handleLoading = async () => {
        setLoading(true); // Start loading
        window.scrollTo(0, 0);
  
        // Simulate loading for demonstration purposes
        await new Promise((resolve) => setTimeout(resolve, 2000));
  
        setLoading(false); // Stop loading
      };
  
      handleLoading();
    }, []);
  const half = Math.ceil(content.length / 2);
  const firstColumnData = content.slice(0, half);
  const secondColumnData = content.slice(half);
  return (
    <React.Fragment>
            {loading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100vh",
                }}
              >
                <Hourglass
                  height={80}
                  width={80}
                  color="#01458e"
                  ariaLabel="loading-content"
                />
              </div>
            ) : (
      <div>
      <HeaderMobile/> 
      <Breadcrumb heading={"Customers"} bTitle={"Customers"}/>
      <Container className="galleryRow ">

        <ul>


<>
<br />

   <div style={{ overflowX: "hider" }}>
      
      <Row>
      {content.length > 0 && content.map((it, index) => (
        <Col lg={3} md={4} sm={6} xs={6} style={{padding:"10px"}}>
        <Card  style={{display:"flex", flexDirection:"column", alignItems:"center", height:"100%", padding:"15px"}}>
        <img src={`${process.env.REACT_APP_GRIPHOLD_API_URL}/${it.logoImage}`} alt="" style={{objectFit:"contain", width:"100px", height:"100px"}}/>
        <br />
        <p style={{textAlign:"center", fontWeight:"bolder"}}>{it.name}</p>
        </Card>
        </Col>))}
      </Row>
    </div>
</>


        </ul>
   
      </Container>
      </div>
       )}
    </React.Fragment>
  );
};

export default CustomerPage;
